import { FormGroup, InputV2, Text } from "@southfields-digital/mxmz-react-ui";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { REQUEST_GET_DATA_PROVIDER_TRANSLATIONS } from "src/redux/reducers/dataProviderTranslation";
import { REQUEST_GET_SPORT_DATA_TOURNAMENT_CALENDAR } from "src/redux/reducers/sportData";
import AskiDaLineup from "./AskiDaLineup";
import Fixtures from "./Fixtures";
import { HockeyLineup } from "./HockeyLineup";
import HockeyStandings from "./HockeyStandings";
import Lineup from "./Lineup";
import MatchStats from "./MatchStats";
import styles from "./SportData.module.scss";
import Standings from "./Standings";
import { Category, getCategory, getPropertyOptionsSportData } from "./utils";

type Props = {
	selectedGraphic: PlaylistGraphic;
	onImport: (propertyId: string, value: string | PropertyValue[]) => void;
};

export default function SportData({ selectedGraphic, onImport }: Props) {
	const dispatch = useDispatch();
	const [property, setProperty] = useState<string>("");

	const selectedProperty = selectedGraphic.graphic.properties.find((p) => p.id === property);
	const category = getCategory(selectedGraphic.graphic.ref, selectedProperty);

	const handleImportStandings = (value: PropertyValue[]) => {
		if (!property) return;
		onImport(property, value);
	};
	const handleImportMatchStat = (value: string | PropertyValue[]) => {
		if (!property) return;
		onImport(property, value);
	};
	const handleImportFixtures = (value: PropertyValue[]) => {
		if (!property) return;
		onImport(property, value);
	};

	useEffect(() => {
		dispatch({ type: REQUEST_GET_SPORT_DATA_TOURNAMENT_CALENDAR });
		dispatch({ type: REQUEST_GET_DATA_PROVIDER_TRANSLATIONS });
	}, []);

	return (
		<div className={styles.Container}>
			<Text as="h2">Import Data</Text>
			<div className={styles.Content}>
				<FormGroup
					className={styles.InputProperties}
					htmlFor="selectedProperty"
					label="Selected property"
				>
					<InputV2
						type="select"
						inputSize="lg"
						id="selectedProperty"
						value={property}
						placeholder="Select a form field to import data"
						options={getPropertyOptionsSportData(
							selectedGraphic.graphic.ref,
							selectedGraphic.graphic.properties,
						)}
						onChange={(e) => setProperty(e.currentTarget.value)}
						// TODO: REMOVE THIS STYLING OVERRIDE WHEN ALL INPUTS USE INPUTV2
						wrapperClassName="!min-h-[42px] !rounded-[4px] !bg-elevated-0 !border-gray-800"
					/>
				</FormGroup>
				{category === Category.Standings && selectedProperty && (
					<Standings
						handleImportData={handleImportStandings}
						selectedGraphic={selectedGraphic}
						selectedProperty={selectedProperty as RepeaterProperties}
					/>
				)}
				{category === Category.Fixtures && selectedProperty && (
					<Fixtures
						handleImportData={handleImportFixtures}
						selectedGraphic={selectedGraphic}
						selectedProperty={selectedProperty as RepeaterProperties}
					/>
				)}
				{category === Category.Lineup && (
					<Lineup
						handleImportData={handleImportFixtures}
						selectedGraphic={selectedGraphic}
						selectedProperty={selectedProperty as RepeaterProperties}
					/>
				)}
				{category === Category.HockeyLineup && (
					<HockeyLineup
						handleImportData={handleImportFixtures}
						selectedGraphic={selectedGraphic}
						selectedProperty={selectedProperty as RepeaterProperties}
					/>
				)}
				{category === Category.HockeyStandings && (
					<HockeyStandings
						handleImportData={handleImportStandings}
						selectedProperty={selectedProperty as RepeaterProperties}
					/>
				)}
				{category === Category.Statistics && (
					<MatchStats
						handleImportData={handleImportMatchStat}
						selectedProperty={selectedProperty}
					/>
				)}
				{category === Category.AskiDaLineup && (
					<AskiDaLineup
						handleImportData={handleImportFixtures}
						selectedGraphic={selectedGraphic}
						selectedProperty={selectedProperty as RepeaterProperties}
					/>
				)}
			</div>
		</div>
	);
}
